export default class CardPaymentSubscription {
  constructor($module) {
    this.$module = $module;

    const cardSelected = document.querySelectorAll(".bc-card__payment");

    cardSelected.forEach(function (paymentCard) {
      paymentCard.addEventListener("click", function (e) {
        if (!paymentCard.classList.contains("bc-card__payment--expired")) {
          this.classList.add("bc-card__payment--chosen");
          this.nextElementSibling.classList.remove("bc-card__payment--chosen");
          this.previousElementSibling.classList.remove(
            "bc-card__payment--chosen"
          );
        }
      });
    });
  }
}
